import { getLegalShieldLink } from '../../../config/legalshield-links';
import { trackAffiliateClick } from '../../../utils/analytics';

export default function PersonalPath() {
  const handleClick = () => {
    trackAffiliateClick('Personal Plan', getLegalShieldLink('PERSONAL_PLAN_URL'), 'Home');
  };

  return (
    <section id="path-personal" className="relative py-20 bg-[#0f1d2e]">
      <div className="max-w-5xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-6" style={{ fontFamily: "'Roboto', sans-serif" }}>
            PATH 1: JUST COVER <span className="text-[#DC2626]">ME &amp; MY FAMILY</span>
          </h2>
          
          <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
            For $30/month, you get unlimited attorney consultations, demand letters on law firm letterhead, 
            contract review, traffic ticket defense, trial coverage, and IRS audit assistance. 
            The same legal firepower the rich use to make problems disappear—now available to you.
          </p>
        </div>

        {/* 3-Step Instructions */}
        <div className="bg-gradient-to-br from-[#0a1628] to-[#1a2332] rounded-2xl p-10 border-2 border-[#DC2626]/30 mb-10">
          <h3 className="text-2xl font-black text-white mb-8 text-center">
            Here's Exactly What To Do:
          </h3>
          
          <div className="space-y-6 mb-10">
            {/* Step 1 */}
            <div className="flex items-start gap-6">
              <div className="w-12 h-12 bg-[#DC2626] rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white font-black text-xl">1</span>
              </div>
              <div>
                <h4 className="text-white font-black text-xl mb-2">Click the button below</h4>
                <p className="text-gray-300 text-lg">
                  This will take you directly to the LegalShield enrollment page.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start gap-6">
              <div className="w-12 h-12 bg-[#DC2626] rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white font-black text-xl">2</span>
              </div>
              <div>
                <h4 className="text-white font-black text-xl mb-2">Choose the recommended personal plan</h4>
                <p className="text-gray-300 text-lg">
                  On the next page, select the middle option (usually called "Personal &amp; Family Legal Plan"). 
                  It's the most popular choice for individuals.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex items-start gap-6">
              <div className="w-12 h-12 bg-[#DC2626] rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white font-black text-xl">3</span>
              </div>
              <div>
                <h4 className="text-white font-black text-xl mb-2">Complete checkout</h4>
                <p className="text-gray-300 text-lg">
                  Fill out the simple form (takes 2 minutes). You'll immediately get an email with your 
                  member portal login and your attorney's direct phone number.
                </p>
              </div>
            </div>
          </div>

          {/* Primary CTA Button */}
          <div className="text-center">
            <a
              href={getLegalShieldLink('PERSONAL_PLAN_URL')}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
              className="inline-flex items-center gap-2 sm:gap-3 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-black text-sm sm:text-base md:text-lg lg:text-xl px-6 sm:px-8 md:px-10 lg:px-12 py-4 sm:py-5 md:py-6 rounded-lg transition-all duration-300 shadow-2xl hover:shadow-[#DC2626]/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <span className="hidden sm:inline">ACTIVATE PERSONAL SHIELD</span>
              <span className="sm:hidden">GET PROTECTED</span>
              <i className="ri-arrow-right-line text-lg sm:text-xl md:text-2xl"></i>
            </a>
          </div>
        </div>

        {/* Micro-copy */}
        <div className="bg-[#0a1628]/50 border border-[#DC2626]/20 rounded-xl p-6 space-y-3">
          <div className="flex items-start gap-3">
            <i className="ri-information-fill text-[#DC2626] text-xl flex-shrink-0 mt-1"></i>
            <p className="text-gray-300 text-base leading-relaxed">
              <span className="text-white font-bold">On the next page you'll see 2–3 plan options.</span> Pick the middle one 
              unless you know you want something different.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <i className="ri-information-fill text-[#DC2626] text-xl flex-shrink-0 mt-1"></i>
            <p className="text-gray-300 text-base leading-relaxed">
              <span className="text-white font-bold">You might see links about "associates" or "business opportunity."</span> Ignore 
              all of that. You're just grabbing the legal plan.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}